import { useEffect } from "react";
import { useParams } from "react-router-dom";

export const ForYouController = () => {
    const params = useParams();
    const { level } = params;

    useEffect(() => {
        window.location.replace(`for-you/${level}.html`);
    }, []);

    return null;
};
